"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = exports.DropdownContainer = exports.Container = exports.ChevronIcon = exports.Error = void 0;
var typography_1 = require("../../typography");
var polished_1 = require("polished");
var styled_components_1 = __importDefault(require("styled-components"));
var icons_1 = require("../../../icons");
exports.Error = (0, styled_components_1.default)(typography_1.BodyText).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        sizes: [theme.typography.fontSizes.fontSize16],
        color: theme.colors.text.error,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", " 0 ", ";\n  text-align: left;\n"], ["\n  margin: ", " 0 ", ";\n  text-align: left;\n"])), (0, polished_1.rem)('4px'), (0, polished_1.rem)('10px'));
exports.ChevronIcon = (0, styled_components_1.default)(icons_1.Chevron).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        primaryColor: theme.colors.border.primary,
        width: 16,
        height: 16,
    });
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: ", ";\n  flex-shrink: 0;\n  align-self: center;\n  rotate: ", ";\n"], ["\n  margin-right: ", ";\n  flex-shrink: 0;\n  align-self: center;\n  rotate: ", ";\n"])), (0, polished_1.rem)(16), function (_a) {
    var rotation = _a.rotation;
    return (rotation === 'up' ? '180deg' : '0deg');
});
exports.Container = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: ", ";\n  align-self: center;\n  display: flex;\n  align-items: center;\n"], ["\n  height: ", ";\n  align-self: center;\n  display: flex;\n  align-items: center;\n"])), (0, polished_1.rem)(35));
exports.DropdownContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-radius: ", ";\n  background-color: ", ";\n"], ["\n  border-radius: ", ";\n  background-color: ", ";\n"])), (0, polished_1.rem)(12), function (_a) {
    var theme = _a.theme, error = _a.error;
    return error && theme.colors.background.error;
});
exports.ErrorMessage = (0, styled_components_1.default)(typography_1.BodyText).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        sizes: [theme.typography.fontSizes.fontSize16],
        color: theme.colors.text.error,
    });
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), (0, polished_1.rem)(16));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
